var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDraftNote = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M495-533a40,40,0,0,0,40-40,40,40,0,0,0-40-40,40,40,0,0,0-40,40A40,40,0,0,0,495-533Z",
    transform: "translate(0)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M0,127.536H1669.565V-800H0Z",
    transform: "translate(0 800)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66615",
    "data-name": "Group 66615",
    transform: "translate(-457 -168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(2 781)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(-72.536 -829.812)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M450-618h91.594v91.594H450Z",
    transform: "translate(71.739 829.014)",
    fill: "rgba(220,220,220,0.24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16365",
    "data-name": "Group 16365",
    transform: "translate(-301.914 -2490.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10313",
    "data-name": "Path 10313",
    d: "M10.047,0H33.491a1.675,1.675,0,0,1,1.675,1.675V43.538a1.675,1.675,0,0,1-1.675,1.675H1.675A1.675,1.675,0,0,1,0,43.538V10.047Z",
    transform: "translate(778.059 1893.575)",
    fill: "#f7f8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10325",
    "data-name": "Path 10325",
    d: "M7.8,0l4.577,8.608L0,4.147Z",
    transform: "matrix(-0.469, 0.883, -0.883, -0.469, 792.116, 1896.189)",
    fill: "#f7f8fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10314",
    "data-name": "Path 10314",
    d: "M11916.225,1025.205v19.056h-35.311v-35.342l9.994-9.994",
    transform: "translate(-11103.001 894.524)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10315",
    "data-name": "Path 10315",
    d: "M11888.354,998.925h21.189",
    transform: "translate(-11097.981 894.524)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10316",
    "data-name": "Path 10316",
    d: "M11881,1008.593h9.846v-9.6",
    transform: "translate(-11102.941 894.569)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71770",
    "data-name": "Group 71770",
    transform: "translate(782.85 1907.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10317",
    "data-name": "Path 10317",
    d: "M11883.86,1007.425h12.615",
    transform: "translate(-11883.86 -1007.426)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10318",
    "data-name": "Path 10318",
    d: "M11883.86,1007.425h7.176",
    transform: "translate(-11868.375 -1007.426)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10324",
    "data-name": "Path 10324",
    d: "M11883.861,1007.425h9.449",
    transform: "translate(-11100.596 913.616)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_71768",
    "data-name": "Group 71768",
    transform: "translate(783.264 1916.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10321",
    "data-name": "Path 10321",
    d: "M11883.86,1007.425h5.895",
    transform: "translate(-11883.86 -1007.426)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10322",
    "data-name": "Path 10322",
    d: "M11883.86,1007.425h2.5",
    transform: "translate(-11873.813 -1007.426)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10323",
    "data-name": "Path 10323",
    d: "M11883.861,1007.425h4.523",
    transform: "translate(-11868.792 -1007.426)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_71769",
    "data-name": "Group 71769",
    transform: "translate(783.264 1911.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10320",
    "data-name": "Path 10320",
    d: "M11883.86,1007.425h4.07",
    transform: "translate(-11883.86 -1007.425)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10319",
    "data-name": "Path 10319",
    d: "M11879.181,1007.425h13.309",
    transform: "translate(-11871.949 -1007.425)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10326",
    "data-name": "Path 10326",
    d: "M11884.788,1023.12c-1.9,1.3-2.736,4.478.43,4.31s3.258-6.357,5.176-8.285,2.814-.69,2.5.57a39.345,39.345,0,0,1-2.748,6.146c-.809,1.429.381,2.1,1.557,1.57s1.822-4.237,2.572-2.368.594,2.731,1.877,2.736,2.7,0,2.7,0",
    transform: "translate(-11101.525 907.489)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1418",
    "data-name": "Rectangle 1418",
    width: 36.84,
    height: 3.349,
    rx: 1.675,
    transform: "matrix(-0.391, 0.921, -0.921, -0.391, 820.182, 1898.028)",
    fill: "#5b57dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10327",
    "data-name": "Path 10327",
    d: "M.676,0,.381.414,0,.946",
    transform: "translate(800.079 1933.587) rotate(-9)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10329",
    "data-name": "Path 10329",
    d: "M0,0,4.012,2.506",
    transform: "translate(804.783 1919.619) rotate(-9)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1417",
    "data-name": "Rectangle 1417",
    transform: "matrix(-0.391, 0.921, -0.921, -0.391, 821.492, 1894.945)",
    fill: "none",
    stroke: "#1c2b35",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.864,
    height: 6.698,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 39.864,
    height: 4.698,
    rx: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10328",
    "data-name": "Path 10328",
    d: "M11905.867,999.554l2.932,1.43a1.748,1.748,0,0,1,.664,1.976c-.447,1.214-5.705,13.614-5.705,13.614",
    transform: "translate(-11087.59 894.948)",
    fill: "none",
    stroke: "#1c2b35",
    strokeLinecap: "round",
    strokeWidth: 2
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDraftNote);
export default ForwardRef;